
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../controlador';
    import publicaciones from './publicaciones/publicaciones.vue';
    import categorias from './categorias/categorias.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            publicaciones,
            categorias,
          
          
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Vue.observable( Model ); }
        public get Modo() { return this.Controlador.Vista.Modo; }
        public set Modo( x: string ) { this.Controlador.Vista.Modo = x; }
        public get Vista() { return this.Controlador.Vista; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }


    }
